module.exports = __webpack_public_path__ + "img/barcodescanner.75295627.png";